import Vuex from 'vuex';
import Vue from 'vue';
import { createStore } from 'vuex-extensions'
import controller from '../_Controller';

Vue.use(Vuex);

export default createStore(Vuex.Store, {
    plugins: [],
    modules: {
        controller
    }
})